<template>
    <div id="app">
        <b-navbar toggleable="md" type="dark" fixed="top" variant="success">
            <b-nav-toggle target="nav_collapse"></b-nav-toggle>
            <b-link class="navbar-brand" to="/">
                <span>PlusFlow</span>
            </b-link>
            <b-collapse style="width: 60%" is-nav id="nav_collapse">
                <b-navbar-nav>
                    <b-nav-item v-if="authenticated" to="/friends">Friends</b-nav-item>
                    <b-nav-item v-if="authenticated" to="/groups">Groups</b-nav-item>
                    <b-nav-item v-if="authenticated" to="/workareas">Workareas</b-nav-item>
                    <b-nav-item v-if="authenticated" to="/organisations">Organisations</b-nav-item>
                    <b-nav-item v-if="!authenticated" to="/login">Login</b-nav-item>
                    <b-nav-item to="logout" v-on:click="logout" v-if="authenticated">Logout</b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item v-if="authenticated" to="#" @click="refresh"><i class="material-icons">&#xE5D5;</i></b-nav-item>
                    <b-nav-item v-if="authenticated" to="/user">{{ user.username }}</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <div class="container">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import router from '@/router'
import timer from '@/utils/timeout'

export default {
    name: 'app',
    computed: {
        authenticated () {
            return this.$store.state.authentication.authenticated
        },
        user () {
            return this.$store.state.authentication.user
        }
    },
    mounted () {
        if (this.$store.state.authentication.authenticated) {
            timer.startTimedFunction(this.refresh, 1000 * 30 * 1)
        }
    },
    destroyed () {
        timer.stopTimedFunction()
    },
    methods: {
        ...mapActions({
            logoutFunction: 'auth_logout',
            refreshFriends: 'friend_list',
            refreshGroups: 'group_list',
            refreshWorkareas: 'workarea_list',
            refreshTasks: 'task_list',
            refreshFavorites: 'favorites_list'
        }),
        ...mapMutations({
            resetFilters: 'FILTER_RESET',
            resetFriends: 'FRIEND_RESET',
            resetGroups: 'GROUP_RESET',
            resetWorkareas: 'WORKAREA_RESET',
            resetTasks: 'RESET_TASK',
            resetFavorites: 'RESET_FAVORITES'
        }),
        refresh: function () {
            this.refreshFavorites()
            if (this.$store.state.task.syncing !== true) {
                this.refreshTasks({offset: 0})
            }
        },
        reset: function () {
            this.resetFilters()
            this.resetFriends()
            this.resetGroups()
            this.resetWorkareas()
            this.resetTasks()
            this.resetFavorites()
        },
        logout: function () {
            this.logoutFunction().then(() => {
                localStorage.clear()
                this.reset()
                timer.stopTimedFunction()
                router.push('/login')
            })
        }
    }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  padding-bottom: 1rem;

  .container {
      padding-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue